import LegalPage from "@/pages/legal/LegalPage";

const sections = [
  {
    heading: "1. Program Description",
    body: [
      "Fortunastrive Services Private Limited may send SMS and text messages to individuals who have explicitly opted in. Messages relate to enquiries, appointments, and requested services.",
    ],
  },
  {
    heading: "2. Consent",
    body: [
      "By checking the optional SMS consent box on our contact form, you agree to receive calls and text messages from Fortunastrive Services Private Limited regarding your enquiry, appointments, and requested services.",
      "Consent to receive SMS is not a condition of purchase. The SMS consent checkbox is optional and unchecked by default, and is kept separate from the mandatory privacy consent.",
    ],
  },
  {
    heading: "3. Message Frequency & Rates",
    body: [
      "Message frequency varies based on your interaction with us. Message and data rates may apply depending on your mobile carrier and plan.",
    ],
  },
  {
    heading: "4. Opt-Out",
    body: [
      "You can cancel SMS messages at any time by replying STOP to any message. After you send STOP, we will confirm your unsubscribe status and stop sending SMS messages. You may receive one final confirmation message.",
    ],
  },
  {
    heading: "5. Help",
    body: [
      "For help at any time, reply HELP to any message, or contact us at the email address below. We will respond with information about the program and how to get assistance.",
    ],
  },
  {
    heading: "6. Privacy",
    body: [
      "Information collected as part of SMS communications is handled in accordance with our Privacy Policy. We do not sell your information. Carriers are not liable for delayed or undelivered messages.",
    ],
  },
];

export default function SmsTerms() {
  return (
    <LegalPage
      testId="sms-terms-page"
      label="Legal"
      title="SMS Terms & Consent Policy"
      updated="January 2026"
      intro="How Fortuna Strive handles SMS and text message communications and consent."
      sections={sections}
    />
  );
}
